import api from '@/api/axios'

export const getBannerHome = async (page = 1, limit = 5) => {
  const response = await api.get(`/projects/banner?page=${page}&limit=${limit}`)
  return response.data
}

export const getProjectListHome = async (page = 1, limit = 10) => {
  const response = await api.get(`/projects/list?page=${page}&limit=${limit}`)
  return response.data
}

export const getProjectOngoingList = async (status = 'Ongoing,Planning', page = 1, limit = 10) => {
  const response = await api.get(`/projects/list?page=${page}&limit=${limit}&status=${status}`)
  return response.data
}

export const getProjectExperienceList = async (status = 'Completed', page = 1, limit = 10) => {
  const response = await api.get(`/projects/list?page=${page}&limit=${limit}&status=${status}`)
  return response.data
}

export const getProjectsByCategoryId = async (id= "", status, page = 1, limit = 10) => {
  const response = await api.get(`/projects/list/${id}?page=${page}&limit=${limit}&status=${status}`)
  return response.data
}

export const getProjectsBySubCategory = async (id= "", status, page = 1, limit = 10) => {
  const response = await api.get(`/projects/list?filter=${id}&fields=categoryId&page=${page}&limit=${limit}&status=${status}`)
  return response.data
}

export const getProjectDetailsBySlug = async (slug) => {
  const response = await api.get(`/projects/details/${slug}`)
  return response.data
}

export const getGalleryByProjectId = async (projectId, page = 1, limit = 10) => {
  const response = await api.get(`/files?limit=${limit}&fields=projectId&filter=${projectId}&page=${page}`)
  return response.data
}